<template>
  <div class="lookInvoiceInfo">
    <el-dialog
      title="查看发票信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :before-close="handleClose"
    >
      <div>
        <div class="title"><span class="title_inside"></span>订单信息</div>
        <div class="order_number">订单编号：{{ orderInfo.orderNumber || "--" }}</div>
        <div class="order_info">
          <span class="info">学员姓名：{{ orderInfo.name || "--" }}</span>
          <span class="info">手机号：{{ orderInfo.phone || "--" }}</span>
          <span class="info">支付金额：{{ orderInfo.payAmt || "--" }}</span>
          <span>支付时间：{{ orderInfo.payTime || "--" }}</span>
        </div>
        <el-divider></el-divider>
        <div class="title"><span class="title_inside"></span>发票信息</div>
        <div class="info_list">
          <div class="invoice_box">
            <div class="invoice_introduce">发票类型</div>
            <div class="invoice_content" v-if="dataInfo.invoiceTitle === 1">个人</div>
            <div class="invoice_content" v-else-if="dataInfo.invoiceTitle === 2">企业</div>
            <div class="invoice_content" v-else>--</div>
          </div>
          <div class="invoice_box">
            <div class="invoice_introduce">发票类目</div>
            <div class="invoice_content">{{ dataInfo.invoiceCategory || '--' }}</div>
          </div>
          <div class="invoice_box">
            <div class="invoice_introduce">发票抬头名称</div>
            <div class="invoice_content">{{ dataInfo.invoiceCustName || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 2">
            <div class="invoice_introduce">纳税人识别号</div>
            <div class="invoice_content">{{ dataInfo.taxpayerNo || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 2">
            <div class="invoice_introduce">公司开户行</div>
            <div class="invoice_content">{{ dataInfo.openingBank || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 2">
            <div class="invoice_introduce">开户行账号</div>
            <div class="invoice_content">{{ dataInfo.openingBankNo || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 2">
            <div class="invoice_introduce">公司注册地址</div>
            <div class="invoice_content">{{ dataInfo.companyRegAddr || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 2">
            <div class="invoice_introduce">公司联系电话</div>
            <div class="invoice_content">{{ dataInfo.companyLinkPhone || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 1">
            <div class="invoice_introduce">手机号</div>
            <div class="invoice_content">{{ dataInfo.phone || '--' }}</div>
          </div>
          <div class="invoice_box" v-if="dataInfo.invoiceTitle === 1">
            <div class="invoice_introduce">发票金额</div>
            <div class="invoice_content">{{ dataInfo.invoiceAmt || '--' }}</div>
          </div>
          <div class="invoice_box">
            <div class="invoice_introduce">邮箱</div>
            <div class="invoice_content">{{ dataInfo.email || '--' }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInvoiceInfo } from "@/api/orderAdmin/invoiceList.js";
import { getOrderDetail } from "@/api/orderAdmin/orderList";
export default {
  data() {
    return {
      dialogVisible: false,
      dataInfo: {},
      orderInfo: {}
    };
  },
  methods: {
    // 初始化
    init(payload) {
      this.getInvoiceInfo(payload.id);
      this.getOrderDetail(payload.orderId);
      this.dialogVisible = true;
    },
    async getInvoiceInfo(id) {
      const res = await getInvoiceInfo({ id });
      this.dataInfo = res.data || {};
    },
    async getOrderDetail(orderId) {
      const res = await getOrderDetail({ orderId });
      this.orderInfo = res.data || {};
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.lookInvoiceInfo {
  ::v-deep .el-dialog__body {
    padding: 10px 20px 30px;
  }
  .title {
    font-size: 18px;
    display: flex;
    align-items: center;
    .title_inside {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #4795f5;
      margin-right: 6px;
    }
  }
  .order_number {
    font-size: 15px;
    line-height: 34px;
    margin-top: 4px;
    margin-left: 6px;
  }
  .order_info {
    font-size: 15px;
    margin-top: 4px;
    margin-left: 6px;
    .info {
      margin-right: 36px;
    }
  }
  .info_list {
    margin-top: 12px;
    margin-left: 6px;
  }
  .invoice_box {
    display: flex;
    border-top: 1px solid #ebeef5;
    font-size: 15px;
    line-height: 40px;

    .invoice_introduce {
      width: 46%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #ebeef5;
    }
    .invoice_content {
      width: 64%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
  }
  .invoice_box:last-child {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>